import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as activityNotificationActions from '../actions/activity-notifications.action';
import {ActivityNotificationService} from "../../activity-notifications/activity-notification.service";
import {map, switchMap} from 'rxjs/operators';
import * as storeActions from "../actions";
import {IActivityNotification} from "../../activity-notifications/activity-notification";
import {IWebsiteActivityNotificationsState} from "../reducers/activity-notifications.reducer";
import {ActivityNotificationMapper} from '../../activity-notifications/activity-notification-mapper';
import * as websiteActions from "../actions/website.action";
import {ActivityAction, ActivityStatus} from "../../activities/activity";
import * as userActions from "../actions/user.action";

@Injectable()
export class ActivityNotificationsEffects {

  constructor(
    private _actions$: Actions,
    private _activityNotificationService: ActivityNotificationService
  ) {
  }

  loadWebsitesSuccess$ = createEffect(() => this._actions$.pipe(
    ofType(websiteActions.LOAD_WEBSITES_SUCCESS),
    switchMap(() => [
      new activityNotificationActions.LoadActivityNotifications(),
      new activityNotificationActions.InitActivityNotificationsSocket()
    ])
  ));

  loadUserSuccess$ = createEffect(() => this._actions$.pipe(
  ofType(userActions.LOAD_USER_SUCCESS),
      switchMap(() => [
        new activityNotificationActions.LoadActivityNotifications(),
        new activityNotificationActions.InitActivityNotificationsSocket()
      ])
    ));

  loadActivityNotifications$ = createEffect(() => this._actions$.pipe(
    ofType(activityNotificationActions.LOAD_ACTIVITY_NOTIFICATIONS),
    switchMap(() => {
      return this._activityNotificationService.getActivityNotifications()
        .pipe(
          map((notificationDatas: any[]) => {
            const websiteActivityNotificationsMap: any = notificationDatas
              .reduce((websiteActivityNotificationMap: {}, activityNotification: IActivityNotification) => {
                let websiteNotifications: IActivityNotification[] = websiteActivityNotificationMap[activityNotification.websiteId];
                if (!websiteNotifications) {
                  websiteNotifications = websiteActivityNotificationMap[activityNotification.websiteId] = [];
                }

                websiteNotifications.push(activityNotification);

                return websiteActivityNotificationMap;
              }, {});

            const activityNotificationEntities: {
              [websiteId: number]: IWebsiteActivityNotificationsState
            } = Object.keys(websiteActivityNotificationsMap)
              .reduce((entities: { [websiteId: number]: IWebsiteActivityNotificationsState }, websiteId: string): {
                [websiteId: number]: IWebsiteActivityNotificationsState
              } => {
                return {
                  ...entities,
                  [websiteId]: {
                    websiteId: websiteId,
                    entities: websiteActivityNotificationsMap[websiteId]
                  }
                };
              }, {});
            return new activityNotificationActions.LoadActivityNotificationsSuccess(activityNotificationEntities);
          })
        );
    })
  ));

  initActivityNotificationsSocket$ = createEffect(() => this._actions$.pipe(
    ofType(activityNotificationActions.INIT_ACTIVITY_NOTIFICATIONS_SOCKET),
    switchMap(() => {
      return this._activityNotificationService.subscribeToActivityNotifications()
        .pipe(
          map((data: any) => {
            // TODO: to fix core bug
            if ([
              ActivityAction.INSTALL,
              ActivityAction.INSTALL_ACTIVATE,
              ActivityAction.INSTALL_ACTIVATE_UPLOAD,
              ActivityAction.UPDATE,
              ActivityAction.DEACTIVATE_DELETE,
              ActivityAction.ACTIVATE,
              ActivityAction.DEACTIVATE
            ].includes(data.action)) {
              if (data.status === ActivityStatus.RUNNING) {
                data.progress = 0;
              } else if ([ActivityStatus.DONE, ActivityStatus.FAILED].includes(data.status)) {
                data.progress = 100;
              }
            }
            // TODO: /to fix core bug

            return new activityNotificationActions.AddActivityNotification(ActivityNotificationMapper.map(data));
          })
        );
    })
  ));

  markReadActivityNotifications$ = createEffect(() => this._actions$.pipe(
    ofType(activityNotificationActions.MARK_READ_ACTIVITY_NOTIFICATIONS),
    map(() => {
      this._activityNotificationService.sendActivityNotificationsReadMessage();

      return new storeActions.Foo();
    })
  ));

}
